import React from 'react';
import styled from 'styled-components';
import HelpAndEnquiriesAccordion from './HelpAndEnquiriesAccordion';
import HowToRedeemAccordion from './HowToRedeemAccordion';
import HowToRedeemOnlineAccordion from './HowToRedeemOnlineAccordion';
import TermsAndConditionsAccordion from './TermsAndConditionsAccordion';
import WhereToRedeemAccordion from './WhereToRedeemAccordion';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

const StyledAccordionFromTablet = `
  & > * {
    margin-bottom: 1rem;
  }
`;
export const StyledAccordionSection = styled.div`
  & > * {
    margin-bottom: 0.5rem;
  }

  &:last-child {
    margin-bottom: 1rem;
  }
  transition: var(--transition-duration);

  ${SCREEN_SIZE.From.Tablet} {
    ${StyledAccordionFromTablet}
  }

  @media print {
    ${StyledAccordionFromTablet}
  }
`;
const InformationSection = () => {
  return (
    <StyledAccordionSection>
      <WhereToRedeemAccordion />
      <HowToRedeemOnlineAccordion />
      <HowToRedeemAccordion />
      <TermsAndConditionsAccordion />
      <HelpAndEnquiriesAccordion />
    </StyledAccordionSection>
  );
};

export default InformationSection;
